/**
 * 门户富文本默认配置数据
 */
export const home = [
  {}
]

/**
 * 大屏富文本默认配置数据
 */
export const bs = [{}
]

/**
 * app富文本默认配置数据
 */
export const appHome = [
  {}
]
